module.exports = __webpack_public_path__ + "static/media/SiamCommercialBank.f8ecbdb9.jpg";